const UserModel = {
    data() {
        return {
            UserModel: {
                fetchUserDetailsFromEmailToken: (params) =>
                    this.$http.get('v2/get-user-from-reset-token', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),


                sendPasswordLinkToEmail: (payload) =>
                    this.$http.post('v2/forgot-password', payload)
                        .then(r => r.data, e => Promise.reject(e.data)),


                getUserRoles: () =>
                    this.$http.get('v2/admin/user/roles')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getUserCompanies: () =>
                    this.$http.get('v2/admin/user/companies')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getActiveCompanySettings: () =>
                        this.$http.get('v2/admin/company-settings', { params: { active: true } })
                        .then(r => r.data, e => Promise.reject(e.data)),
                
                getCurrentUser: () =>
                        this.$http.get('v2/admin/user/session')
                        .then(r => r.data, e => Promise.reject(e.data)),
 
                fetchSubsidiary: (id) =>
                        this.$http.get(`v2/admin/company-settings/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                listSubsidiaries: (params) =>
                        this.$http.get('v2/admin/company-settings', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),

                editCompanySettings: (id, data) =>
                        this.$http.patch(`v2/admin/company-settings/${id}`, data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getCurrentCompany: () =>
                    this.$http.get('v2/admin/user/companies/current')
                        .then(r => r.data, e => Promise.reject(e.data)),


                switchUserCompanies: companyId =>
                    this.$http.get(`v2/admin/user/switch-company/${companyId}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                hasUserAppliedForAtLeastOneJob: (payload) =>
                    this.$http.post(`v2/admin/user/check-client-has-candidate`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                uploadFile: (data, headers) =>
                    this.$http.post('/v2/file/upload', data, headers)
                        .then(r => r.data, e => Promise.reject(e.data)),

                parseCv: (baseUrl, data, token) =>
                    this.$http.post(`${baseUrl}`, data, {
                        headers: {
                            'authorizationtoken': token,
                            'Content-Type' : 'multipart/form-data'
                        }
                    })
                    .then(r => r.data, e => Promise.reject(e.data)),

                applicantScoreRequest: (payload) =>
                    this.$http.post(`/v2/score-candidate`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                addSubsidiary: (data, headers) =>
                    this.$http.post('v2/admin/company-settings/create/company', data, headers)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getIntegrationStatus: () =>
                    this.$http.get('v2/admin/company-settings/integration-details')
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                fetchCompanySubsidiaries: (params) =>
                    this.$http.get('api/v2/rms-company-subsidiaries', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                getEmployees: (params) =>
                    this.$http.get('api/v1/get/employees', { params })
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                whitelistCandidates: data =>
                    this.$http.post('v2/admin/jobs/whitelist-candidates', data )
                        .then(r => r.data, e => Promise.reject(e.data)),
            }
        }
    }
}

export default UserModel;
